/**
 * Email domains that skip Cloudflare Turnstile verification on the public
 * auth routes, matched case-insensitively against the full domain of an
 * unproven request-body `email`.
 *
 * Shared between `apps/api`'s `TurnstileGuard` (the actual bypass — skips the
 * server-side `siteverify` call) and `apps/web`'s `useTurnstile` hook (hides
 * the widget so the UI doesn't ask for a CAPTCHA the server will never check).
 * A single source of truth matters here in one direction specifically: if the
 * two lists ever disagreed, an unlisted-on-web/listed-on-api mismatch is
 * merely cosmetic (widget shows, server ignores it), but a
 * listed-on-web/unlisted-on-api mismatch would hide the widget for a domain
 * the API still requires a token for, so the submit 403s with no way to
 * produce one — never duplicate this list, extend it here.
 *
 * This is a domain-only bypass, not an identity check — anyone typing an
 * address on one of these domains skips the check, not just staff. Keep this
 * list to internal domains where that trade-off is accepted.
 *
 * Each consumer does its own exact-match against this list (lowercase the
 * email's domain, compare for equality — never a suffix/substring match,
 * which would also let `evil-saleshandy.com` or `saleshandy.com.evil.com`
 * through). This package holds no runtime logic, only the shared constant.
 */
export const TURNSTILE_BYPASS_EMAIL_DOMAINS = ['saleshandy.com', 'trulyinbox.com'] as const;
